<template>
  <div :class="{relative: true, 'clickable': readonly}" v-on:mouseenter="mouseEnter" v-on:mouseleave="mouseLeft" v-on:click="onCardClick">
    <s-card :border="true" :padding="false" >
      <div class="flex justify-start items-center height-100">
        <div >
          <div v-if="viewable" class="two-column-grid items-center">
            <div class="card-img">
              <img class="img-small" :src="src" />
            </div>
            <div class="flex flex-column">
              <div class="title-label">{{ fileName }}</div>
              <div class="value-label">{{ fileSize }}</div>
            </div>
          </div>
          <div v-else class=" p-12 two-column-grid items-center">
            <div >
              <img :src="getIconUrl(icon)" class="card-img-icon"/>
            </div>
            <div class="flex flex-column">
              <div class="title-label">{{ fileName }}</div>
              <div class="value-label">{{ fileSize }}</div>
            </div>
          </div>


        </div>
      </div>
    </s-card>
    <div v-if="!readonly" class="absolute right-0 top-0 translate-right-top">
      <transition name="fade">
        <s-button v-if="showRemoveButton" :round="true" :mini="true" icon="close.png" tool-tip="Remove" title="''" @clicked-item="onRemove"/>
      </transition>
    </div>
    <div v-if="readonly" class="absolute right-0 top-0 translate-right-top">
      <transition name="fade">
        <s-button v-if="showRemoveButton" :round="true" :mini="true" icon="download.png" tool-tip="Remove" title="''" @clicked-item="onRemove"/>
      </transition>
    </div>

  </div>
</template>

<script>
import SButton from "./SButton";
import SCard from "./SCard";

export default {
  name: "SFileBox",
  components:{
    SButton,
    SCard,
  },
  props: {
    viewable: {default: false},
    icon: {default: 'file-icon.png'},
    src: {default: ''},
    fileName: {default: ''},
    fileSize: {default: ''},
    readonly: {default: false}
  },

  data: function (){
    return {
      showRemoveButton: false,
    }
  },
  methods: {
    attachmentClicked(){

    },
    mouseEnter: function (event) {
      // this.$emit("input", event.target.value);
      this.showRemoveButton = true;
    },
    mouseLeft: function (){
      this.showRemoveButton = false;
    },
    onRemove: function (){
      this.$emit("on-remove");
    },

    getIconUrl(icon) {
      return require("../assets/" + icon);
    },

    onCardClick() {
      this.$emit('on-file-click',true);
    }
  }
}
</script>

<style scoped lang="scss">


.flex-grow{
  flex-grow: 1;
  align-self: stretch;
}

.message-box {
  height: 57px !important;
  display: flex;
  position: relative;
}

.container {
  height: 100%;
  width: 100%;
}

.flex {
  display: flex;
  flex: 1;
}
.flex-column {
  flex-direction: column;
}
.flex-row {
  flex-direction: row;
}

.justify-center {
  justify-content: center;
}
.content-stretch {
  align-content: stretch;
}
.content-center {
  align-content: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.items-center {
  align-items: center;
}

.width-100{
  width: 100%;
}
.height-100{
  height: 100%;
}
.font-14{
  font-size: 16px;
}

.no-resize {
  resize: none;
}

.pb-16 {
  padding-bottom: 16px;
}
.pb-24 {
  padding-bottom: 24px;
}
.pr-12 {
  padding-right:12px;
}
.p-8{
  padding: 8px;
}
.pr-0{
  padding-right:0;
}

.p-12 {
  padding: 18px;
}
.pl-64{
  padding-left: 64px;
}

.pl-64{
  padding-left: 64px;
}

.two-column-grid {
  display: grid;
  grid-template-columns: 0.5fr 2fr;
  grid-column-gap: 30px;
}

.card-img{
  height: 90px;
  object-fit: cover;
}

.img-small {
  max-height: 100%;
}


.card-img-icon {
  height: 50px;
  width: 50px;
}


.translate-right-top {
  transform: translate(50%,-50%);
}
.clickable {
  cursor: pointer;
}

</style>